import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';
// Custom packages - Component
import { GasMetersListComponent } from 'src/app/modules/gas-meters/pages/gas-meters-list/gas-meters-list.page';
var ɵ0 = {
    permissions: ['canReadPropertiesList']
};
var routes = [
    {
        path: 'list',
        component: GasMetersListComponent,
        canActivate: [RoleGuard],
        data: ɵ0,
    },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var GasMetersRoutingModule = /** @class */ (function () {
    function GasMetersRoutingModule() {
    }
    return GasMetersRoutingModule;
}());
export { GasMetersRoutingModule };
export { ɵ0 };
